import { useLocalization } from 'localization';

export function getTokenInfo(token: string) {
  try {
    const { f } = useLocalization();
    const payload = JSON.parse(atob(token.split('.')[1]));
    const now = Date.now();
    const formatDate = (ts: number) => f(new Date(ts * 1000), { date: 'short', time: 'short' });
    const formatDuration = (ms: number) => `${Math.floor(ms / 60000)}m ${Math.floor((ms % 60000) / 1000)}s`;

    return {
      issuedAt: formatDate(payload.iat),
      expiresAt: formatDate(payload.exp),
      timeToExpiry: formatDuration(Math.max(0, payload.exp * 1000 - now)),
      tokenAge: formatDuration(now - payload.iat * 1000),
      isExpired: payload.exp && now > payload.exp * 1000,
    };
  } catch {
    return { error: 'Failed to parse JWT token' };
  }
}
